module.exports = __webpack_public_path__ + "img/ezwrite6_education_bg_space.90c29ad3.svg";